import * as React from "react";
import Container from "@mui/material/Container";
import { Box, Stack, Card, CardHeader, CardContent, Button, Link, Typography, Divider } from "@mui/material";
import { List, ListItem, ListItemText } from "@mui/material";
import { useParams } from "react-router-dom";
import GuestTanitaSection from "../sections/GuestTanitaSection";


export default function Page() {
  const { report_code } = useParams();


  return (

    <Container maxWidth="false">
      <Box
        container
        display={"flex"}
        justifyContent={"center"}
        sx={{
          marginTop: 5,
          // height: "calc(100vh - 128px)",
        }}
      >
        <Stack direction="column" gap={1}>
          <Typography sx={{ mb: 4 }} variant="h3">健康分析報告</Typography>

          <GuestTanitaSection reportCode={report_code} autoLoad={true} />

          <Typography variant="body1">Powered by <b>Tanita</b></Typography>


        </Stack>
      </Box>

    </Container>
  );

}
